import { useEffect } from 'react';
import { loadCssVars, loadFontStyles } from '../components/cmv2/utils/globalStyles';
export const useLoadGlobalStylesCssVars = cssVarData => {
  const {
    css,
    fontStyles
  } = cssVarData || {};
  useEffect(() => {
    if (!css) return;
    loadCssVars(css);
  }, [css]);
  useEffect(() => {
    if (!fontStyles) return;
    loadFontStyles(fontStyles.join('\n'));
  }, [fontStyles]);
};